import React, { useEffect, useState } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsRemaining,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const RemainingStatus = ({ query = "", userPermission }) => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // Состояния для пагинации
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20); // всегда 20 записей
  const [totalCount, setTotalCount] = useState(0);

  // Функция загрузки данных
  const loadData = async (page = 1, pageSize = 20) => {
    try {
      setIsLoading(true);
      // Здесь для "Остатков" используем state ACTIVE и status как массив для оставшихся заказов
      const res = await fetchStatuses(
        "ACTIVE",
        ["ORDER_DELIVERED", "ORDER_INSTALLED"],
        query,
        setOrders,
        setIsLoading,
        setTotalCount,
        pageSize,
        page,
        true // флаг для оставшихся
      );
      // Допустим, сервер возвращает:
      //   res.data.application – массив заявок,
      //   res.data.currentPage – номер текущей страницы,
      //   res.data.totalCount – общее число записей.
      setCurrentPage(res.data.currentPage || page);
      setLimit(pageSize);
      setTotalCount(res.data.totalCount || 0);
    } catch (err) {
      console.error("Error fetching RemainingStatus:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData(1, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
    loadData(page, pageSize);
  };

  return (
    <div>
      <Table
        size="small"
        bordered
        loading={isLoading}
        dataSource={getOrderStatusDataSource(orders)}
        columns={orderStatusColumnsRemaining}
        pagination={false} // отключаем встроенную пагинацию Ant Design
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
            />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          onChange={handlePageChange}
          showSizeChanger
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default RemainingStatus;
